import { render, staticRenderFns } from "./ProductItem.component.vue?vue&type=template&id=1d9f7920&scoped=true"
import script from "./ProductItem.component.vue?vue&type=script&lang=js"
export * from "./ProductItem.component.vue?vue&type=script&lang=js"
import style0 from "./ProductItem.component.vue?vue&type=style&index=0&id=1d9f7920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9f7920",
  null
  
)

export default component.exports